import type { Experiencia } from "./model";

/**
 * Experiencias de la mas reciente a la mas antigua.
 *
 * Port de `src/shared/sortExperiences.ts`, con las fechas ya en "YYYY-MM", que
 * se ordenan bien como texto (es justo para lo que sirve ese formato).
 *
 * Los trabajos actuales van primero: no tienen fecha de fin, y compararlos por
 * la de inicio los hundiria por debajo de un trabajo anterior que termino
 * despues de que este empezara.
 */
export const ordenarExperiencias = (exps: Experiencia[]): Experiencia[] =>
  [...exps].sort((a, b) => {
    if (a.current_job !== b.current_job) return a.current_job ? -1 : 1;

    const fa = (a.end_date ?? a.start_date ?? "").trim();
    const fb = (b.end_date ?? b.start_date ?? "").trim();

    if (fa > fb) return -1;
    if (fa < fb) return 1;
    return 0;
  });
